import pick from 'lodash/pick';

import { RpFulfillmentConfig } from '@evidentid/gateway-api-client/src/models';

export function extractFulfillmentConfig(source: Required<RpFulfillmentConfig>): RpFulfillmentConfig {
    return pick(source, [ 'enabled', 'primaryColor', 'secondaryColor', 'text', 'buttonLabel', 'fulfillmentUrl', 'logoUri' ]);
}
